export const roles = Object.freeze({
  SuperAdmin: 'Super Admin',
  CustomerAdmin: 'Customer Admin',
  User: 'User',
  SubAdmin: 'Sub Admin',
});
